import React, { lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom'; // Remove BrowserRouter
const Home = lazy(() => import('./pages/Home'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const DataUpload = lazy(() => import('./pages/DataUpload/DataUpload'));
const DataUploadChild = lazy(() => import('./pages/DataUpload/DataUploadChild'));
// import Reports from './pages/Reports/Reports';
const LoginPage = lazy(() => import('./pages/Login/Login'));
const ProfilePage = lazy(() => import('./pages/Profile/profile'));
const S3ToS3Upload = lazy(() => import('./pages/S3ToS3Upload'));
const SourceDetailsPage = lazy(() => import('./pages/S3ToS3Upload/SourceDetailsPage'));
const JobDetailsPage = lazy(() => import('./pages/S3ToS3Upload/JobDetailsPage'));
const AppRouter = () => {
  const location = useLocation();
  return (
    <Suspense fallback={<div role="status" aria-live="polite">Loading...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/data-upload" element={<DataUpload key={location.pathname} />} />
        <Route path="/data-upload/:datasetId" element={<DataUploadChild />} />
        <Route path="/s3-upload" element={<S3ToS3Upload />} />
        <Route path="/job-details/:jobId" element={<JobDetailsPage />} />
        <Route path="/s3-upload/source/:sourceId" element={<SourceDetailsPage />} />
        {/* <Route path="/report" element={<Reports />} /> */}
        <Route path="/profile" element={<ProfilePage />} />
        {/* Add other routes as needed */}
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
